// React for Website

import React, { useState, useEffect } from "react";
//outsource
import { Row, Col, Modal, Form, Button, message } from "antd";
import moment from "moment";

//components
import SearchStaff from "./component/search_staff";
import StaffUserName from "./component/staff_user_name";
import StaffFullName from "./component/staff_full_name";
import StaffPreferredName from "./component/staff_preferred_name";
import StaffPhone from "./component/staff_phone";
import StaffEmail from "./component/staff_email";
import StaffDateOfBirth from "./component/staff_date_of_birth";

//redux
import { useDispatch, useSelector } from "react-redux";
import { addStaff } from "../../../store/staff/staff.action";
import { getAllUser } from "../../../store/user/user.action";
import { allSelector } from "../../../store/user/user.selector";

const DialogStaffAdd = (props) => {
  // -------------------------- VAR --------------------------
  const { data, open, setOpen, branch } = props;
  const [formAddStaff] = Form.useForm();

  // console.log(data, "data");
  // console.log("branch", branch);
  // -------------------------- STATE --------------------------
  const [id, setId] = useState("");
  const [loading, setLoading] = useState(false);
  // -------------------------- REDUX --------------------------
  const dispatch = useDispatch();
  const allUser = useSelector(allSelector);
  // -------------------------- FUNCTION --------------------------
  const onFinish = (values) => {
    if (allUser && id !== "") {
      setLoading(true);
      const exist = data?.find((item) => item.id === id);
      if (exist) {
        message.error("Duplicate staff");
        setLoading(false);
      } else {
        if (branch?.owner === id) {
          message.error("Cannot add branch's owner");
          setLoading(false);
        } else {
          // ---- add staff vào trong branch ------
          // dispatch(
          //   updateAccessShop({
          //     branchId: branch.id,
          //     coop: [...branch.coop, id],
          //   })
          // );

          dispatch(
            // ----- add staff info in staff collection -----
            addStaff({ branch, staff: id }, (response) => {
              setLoading(false);
              if (response.status === 200) {
                message.success("The staff was add successfully!");
                setOpen(false);
                formAddStaff.resetFields();
              }
            })
          );
        }
      }
    }
  };

  const onSelect = (id) => {
    const targetUser = allUser?.find((item) => item.id === id);
    const { firstName, lastName, dob, ...data } = targetUser;
    // console.log(data);
    const fullName = `${firstName} ${lastName}`;
    const username = data?.username || "";
    const dateofbirth = moment(dob, "DD/MM/YYYY");
    const update = {
      ...data,
      fullName,
      username,
      dob: dateofbirth,
    };

    // console.log("update", update);

    setId(id);
    formAddStaff.setFieldsValue(update);
  };

  const onFinishFailed = (errors) => {
    console.log("errors", errors);
  };

  // -------------------------- EFFECT --------------------------
  useEffect(() => {
    dispatch(getAllUser());
  }, [dispatch]);

  // -------------------------- RENDER --------------------------
  const renderFooter = () => {
    return (
      <Row>
        <Col align="left" span={12}>
          <Button
            onClick={() => setOpen(false)}
            style={{ width: 200 }}
            type="default"
            loading={loading}
          >
            Cancel
          </Button>
        </Col>
        <Col align="right" span={12}>
          <Button
            form="form-add-staff"
            htmlType="submit"
            style={{ width: 200 }}
            type="primary"
            loading={loading}
          >
            Add
          </Button>
        </Col>
      </Row>
    );
  };

  const renderFormBody = () => {
    return (
      <Row gutter={[20, 20]}>
        <Col lg={24} md={24} sm={24} xs={24}>
          <SearchStaff data={allUser} onSelect={onSelect} />
        </Col>
        <Col lg={12} md={12} sm={24} xs={24}>
          <StaffUserName disabled={true} />
        </Col>
        <Col lg={12} md={12} sm={24} xs={24}>
          <StaffFullName disabled={true} />
        </Col>
        <Col lg={12} md={12} sm={24} xs={24}>
          <StaffPreferredName disabled={true} />
        </Col>
        <Col lg={12} md={12} sm={24} xs={24}>
          <StaffDateOfBirth disabled={true} />
        </Col>
        <Col lg={12} md={12} sm={24} xs={24}>
          <StaffPhone disabled={true} />
        </Col>
        <Col lg={12} md={12} sm={24} xs={24}>
          <StaffEmail disabled={true} />
        </Col>
      </Row>
    );
  };
  // -------------------------- MAIN --------------------------
  return (
    <Modal
      title="Add Staff"
      visible={open}
      onCancel={() => setOpen(false)}
      footer={renderFooter()}
      width={700}
    >
      <Form
        id="form-add-staff"
        autoComplete="off"
        layout="vertical"
        form={formAddStaff}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
      >
        {renderFormBody()}
      </Form>
    </Modal>
  );
};

export default DialogStaffAdd;
